import Dashboard from './views/Dashboard'
import RangeManagerGridView from './views/RangeManagerGridView'
import RangeSetup from './views/RangeSetup'

const RangeMembershipsRoutes = [
    {
        path: '/range-memberships',
        component: () => import(/* webpackChunkName: "range-memberships-module" */ './RangeMembershipsModule.vue'),
        children: [
            { path: '', name: 'Range & Memberships Dashboard', component: Dashboard },
            { path: 'range-manager', name: 'Range Manager', component: RangeManagerGridView },
            { 
                path: 'range-setup', name: 'Range Bay Setup', component: () => import(/* webpackChunkName: "range-setup" */ './views/RangeSetup.vue'), props: true, children: [
                    { path: ':product_id', name: 'Range Bay Setup Detail', props: true }
                ]
            },
            {
                path: 'range-schedule', name: 'Range Schedule', component: () => import(/* webpackChunkName: "range-schedule" */ './views/RangeSchedule.vue'), props: true, children: [
                    { path: ':product_id', name: 'Range Schedule Detail', props: true }
                ]
            },
            {
                path: 'memberships', name: 'Memberships', component: () => import(/* webpackChunkName: "memberships" */ './views/Memberships.vue'), props: true, children: [
                    { path: ':membership_id', name: 'Membership Detail', props: true }
                ]
            },
            {
                path: 'members', name: 'Members', component: () => import(/* webpackChunkName: "members" */ './views/Members.vue'), props: true, children: [
                    { path: ':contact_membership_id', name: 'Member Detail', props: true }
                ]
            },
            {
                path: 'waivers', name: 'Waivers', component: () => import(/* webpackChunkName: "waivers" */ './views/Waivers.vue'), props: true, children: [
                    { path: ':contact_id', name: 'Waiver Detail', props: true }
                ]
            },
            {
                path: 'rentals', name: 'Rentals', component: () => import(/* webpackChunkName: "rentals" */ './views/Rentals.vue'), props: true, children: [
                    { path: ':product_id', name: 'Rental Detail', props: true }
                ]
            },
            {
                path: 'classes', name: 'Manage Classes', component: () => import(/* webpackChunkName: "classes" */ './views/Classes.vue'), props: true, children: [
                    { path: ':class_detail_id', name: 'Class Detail', props: true }
                ]
            },
            {
                path: 'class-calendar', name: 'Class Calendar', component: () => import(/* webpackChunkName: "class-calendar" */ './views/ClassCalendar.vue'), props: true, children: [
                    { path: 'calendar', name: 'Class Calendar View', props: true },
                    { path: 'enrollment', name: 'Class Enrollment View', props: true }
                ]
            },
            {
                path: 'membership-application-pages', name: 'Membership Application Pages', component: () => import(/* webpackChunkName: "membershipapplicationpages" */ './views/MembershipApplicationPages.vue'), props: true
            }
        ]
    }
]

export default RangeMembershipsRoutes
